export const MALE = "MALE";
export const FEMALE = "FEMALE";

export const TRANSPORT_TYPE = {
  BUS: "BUS",
  TRAIN: "TRAIN",
  FLIGHT: "FLIGHT",
};

export const FLIGHT_CLASS_TYPE = {
  BUSINESS_CLASS: "BUSINESS_CLASS",
  ECONOMY_CLASS: "ECONOMY_CLASS",
};

export const UPCOMING = "UPCOMING";
export const CANCELED = "CANCELED";
export const PAST = "PAST";